// extracted by mini-css-extract-plugin
export var tosLink = "_69-0";